import axios from "axios";
export default axios.create({
  baseURL: "https://j9qmzclk8i.execute-api.us-east-1.amazonaws.com/dev",
});
